import axios from 'axios'
import qs from 'qs'

import * as utils from 'utils'

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_NEW,
})

instance.interceptors.request.use(
    function (config) {
        config.headers['gen-api-key'] = process.env.REACT_APP_DOT_KEY

        return config
    },
    function (error) {
        // 오류 요청을 보내기전 수행할 일
        return Promise.reject(error)
    },
)

export const apis = {
    get_district: params => instance.get(utils.API_URL.COMMON.DISTRICT, { params }).then(res => res.data), //행정구역(시도/구군)목록 조회
    get_station_region: () => instance.get(utils.API_URL.MAP.STATAION_REGIONS).then(res => res.data), //고고로 스테이션이 설치된 시도/구군 목록 조회.
    get_station_list: params => instance.get(utils.API_URL.MAP.STATION_LIST, { params }).then(res => res.data), //고고로 스테이션이 설치된 시도/구군 목록 조회.
    get_network_list: params => instance.get(utils.API_URL.MAP.NETWORK_LIST, { params }).then(res => res.data), //서비스점 목록 조회
}
